import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ExamHistory } from '../workspace/types';
import {
    kycThunk,
    postCodingExamAnswerThunk,
    runCodeEditorSnippetThunk,
    getCodingExamQuestionThunk,
} from './thunks';
import {
    State,
    KYCStatus,
    CodingExamStep,
    CodingExamQuestion,
    MultipleChoiceExamStep,
    RecruitingInterviewStep,
} from './types';

const initialState: State = {
    selectedExam: null,
    KYC_ID_Photo: null,
    KYC_Status: 'Pending',
    exitExamModal: false,
    examRulesModal: false,
    codeEditorOutput: null,
    codingExamStep: 'KYC',
    KYC_Personal_Photo: null,
    codingExamQuestion: null,
    fetchingCodingExam: false,
    codingExamBreakModal: false,
    multipleChoiceExamStep: 'KYC',
    recruitingInterviewStep: 'KYC',
    fetchingCodeEditorOutput: false,
    codingExamScreenRecordUploadPercentage: 0,
};

export const examSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setMultipleChoiceExamStep: (state, action: PayloadAction<MultipleChoiceExamStep>) => {
            state.multipleChoiceExamStep = action.payload;
        },
        setCodingExamStep: (state, action: PayloadAction<CodingExamStep>) => {
            state.codingExamStep = action.payload;
        },
        setKYC_ID_Photo: (state, action: PayloadAction<string | null>) => {
            state.KYC_ID_Photo = action.payload;
        },
        setKYC_Personal_Photo: (state, action: PayloadAction<string | null>) => {
            state.KYC_Personal_Photo = action.payload;
        },
        setKYC_Status: (state, action: PayloadAction<KYCStatus>) => {
            state.KYC_Status = action.payload;
        },
        setCodingExamQuestion: (state, action: PayloadAction<CodingExamQuestion | null>) => {
            state.codingExamQuestion = action.payload;
        },
        setExamRulesModal: (state, action: PayloadAction<boolean>) => {
            state.examRulesModal = action.payload;
        },
        setCodingExamScreenRecordUploadPercentage: (state, action: PayloadAction<number>) => {
            state.codingExamScreenRecordUploadPercentage = action.payload;
        },
        setExitExamModal: (state, action: PayloadAction<boolean>) => {
            state.exitExamModal = action.payload;
        },
        setSelectedExam: (state, action: PayloadAction<ExamHistory | null>) => {
            state.selectedExam = action.payload;
        },
        setRecruitingInterviewStep: (state, action: PayloadAction<RecruitingInterviewStep>) => {
            state.recruitingInterviewStep = action.payload;
        },
        setCodingExamBreakModal: (state, action: PayloadAction<boolean>) => {
            state.codingExamBreakModal = action.payload;
        },
        setCodeEditorOutput: (state, action: PayloadAction<string | null>) => {
            state.codeEditorOutput = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(kycThunk.fulfilled, (state) => {
                state.KYC_Status = 'Approved';
            })
            .addCase(kycThunk.rejected, (state) => {
                state.KYC_Status = 'Reject';
            })
            .addCase(postCodingExamAnswerThunk.pending, (state) => {
                state.fetchingCodingExam = true;
            })
            .addCase(postCodingExamAnswerThunk.rejected, (state) => {
                state.fetchingCodingExam = false;
            })
            .addCase(postCodingExamAnswerThunk.fulfilled, (state) => {
                state.fetchingCodingExam = false;
            })
            // .addCase(getCodingExamQuestionThunk.pending, (state) => {
            //     state.fetchingCodingExam = true;
            // })
            // .addCase(getCodingExamQuestionThunk.rejected, (state) => {
            //     state.fetchingCodingExam = false;
            // })
            // .addCase(getCodingExamQuestionThunk.fulfilled, (state, action) => {
            //     state.fetchingCodingExam = false;
            //     state.codingExamStep = 'Exam';
            //     state.codeEditorOutput = null;
            //     state.codingExamQuestion = action.payload;
            // })
            .addCase(runCodeEditorSnippetThunk.fulfilled, (state, action) => {
                state.codeEditorOutput = action.payload;
                state.fetchingCodeEditorOutput = false;
            })
            .addCase(runCodeEditorSnippetThunk.pending, (state) => {
                state.fetchingCodeEditorOutput = true;
            })
            .addCase(runCodeEditorSnippetThunk.rejected, (state) => {
                state.fetchingCodeEditorOutput = false;
            })
    }
});

export const {
    setKYC_Status,
    setKYC_ID_Photo,
    setSelectedExam,
    setExitExamModal,
    setExamRulesModal,
    setCodingExamStep,
    setCodingExamQuestion,
    setKYC_Personal_Photo,
    setCodingExamBreakModal,
    setMultipleChoiceExamStep,
    setRecruitingInterviewStep,
    setCodingExamScreenRecordUploadPercentage,
    setCodeEditorOutput
} = examSlice.actions;